import { graphql } from '@e-socna/data-layer';

export const DocumentEditorResolvers_QuickAccess_ServicesInfo_Fragment =
  graphql(`
    fragment DocumentEditorResolvers_QuickAccess_ServicesInfo_Fragment on ServicesInfo {
      consolidation {
        serviceUsagesGroups {
          _id
          index
          groupingMode
          isOptional
          label
          totalMode

          manualTotal {
            vatId {
              value
            }
          }

          serviceUsages {
            _id

            compiled {
              consolidation {
                quantity {
                  value
                  unitId
                }

                settings {
                  showAmountsInQuotation
                  showCostsInQuotation
                  showMaterialsInQuotation
                  showQuantitiesInQuotation
                }

                service {
                  code
                  title
                  content

                  costUsages {
                    _id

                    quantity {
                      unitId
                      value
                    }

                    cost {
                      code
                      content
                      label
                      title

                      costMargin {
                        label
                        variableValue

                        fixedValue {
                          currencyId
                          value
                        }
                      }

                      ... on FixedCost {
                        amount {
                          currencyId
                          value
                        }
                      }

                      ... on VariableCost {
                        value
                      }
                    }
                  }

                  materialUsages {
                    _id

                    quantity {
                      unitId
                      value
                    }

                    material {
                      code
                      content
                      label
                      title
                    }
                  }

                  value {
                    discountPercentage
                    vatId

                    discountAmount {
                      currencyId
                      value
                    }

                    priceExcludingVat {
                      currencyId
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
      totalCalculation {
        details {
          en
          fr
        }
        result {
          discountAsAmount {
            currencyId
            value
          }
          discountAsPercentage
          discountedAmountExcludingVat {
            currencyId
            value
          }
          discountedAmountIncludingVat {
            currencyId
            value
          }
          undiscountedAmountExcludingVat {
            currencyId
            value
          }
          vatAsAmount {
            currencyId
            value
          }
          vatAsPercentage
        }
        status
        totalMode
      }

      serviceUsagesGroupTotalCalculations {
        groupId

        totalCalculation {
          result {
            undiscountedAmountExcludingVat {
              currencyId
              value
            }
            discountAsAmount {
              currencyId
              value
            }
            discountedAmountExcludingVat {
              currencyId
              value
            }
            discountedAmountIncludingVat {
              currencyId
              value
            }
            vatAsAmount {
              currencyId
              value
            }
            discountAsPercentage
            vatAsPercentage
          }
        }
      }
    }
  `);

export const DocumentEditorResolvers_QuickAccess_Mission_Fragment = graphql(`
  fragment DocumentEditorResolvers_QuickAccess_Mission_Fragment on Mission {
    distances {
      fastestFromQuotationEmitterInKm
      longestFromQuotationEmitterInKm
      shortestFromQuotationEmitterInKm
    }

    quotationInfo {
      workflowId
      stateId

      snapshot {
        selectedOptionGroupIds

        serviceUsagesGroups {
          _id
          subMissionId
          index
          groupingMode
          isOptional
          label
          totalMode

          manualTotal {
            vatId
            discountPercentage

            discountAmount {
              currencyId
              value
            }

            priceExcludingVat {
              currencyId
              value
            }
          }

          serviceUsages {
            _id

            consolidation {
              quantity {
                value
                unitId
              }

              settings {
                showAmountsInQuotation
                showCostsInQuotation
                showMaterialsInQuotation
                showQuantitiesInQuotation
              }

              service {
                code
                title
                content

                costUsages {
                  _id

                  quantity {
                    unitId
                    value
                  }

                  cost {
                    code
                    content
                    label
                    title

                    costMargin {
                      label
                      variableValue

                      fixedValue {
                        currencyId
                        value
                      }
                    }

                    ... on FixedCost {
                      amount {
                        currencyId
                        value
                      }
                    }

                    ... on VariableCost {
                      value
                    }
                  }
                }

                materialUsages {
                  _id

                  quantity {
                    unitId
                    value
                  }

                  material {
                    code
                    content
                    label
                    title
                  }
                }

                value {
                  discountPercentage
                  vatId

                  discountAmount {
                    currencyId
                    value
                  }

                  priceExcludingVat {
                    currencyId
                    value
                  }
                }
              }
            }
          }
        }

        totalCalculation {
          details {
            en
            fr
          }
          status
          result {
            discountAsAmount {
              currencyId
              value
            }
            discountAsPercentage
            discountedAmountExcludingVat {
              currencyId
              value
            }
            discountedAmountIncludingVat {
              currencyId
              value
            }
            undiscountedAmountExcludingVat {
              currencyId
              value
            }
            vatAsAmount {
              currencyId
              value
            }
            vatAsPercentage
          }
        }

        serviceUsagesGroupTotalCalculations {
          groupId

          totalCalculation {
            result {
              undiscountedAmountExcludingVat {
                currencyId
                value
              }
              discountAsAmount {
                currencyId
                value
              }
              discountedAmountExcludingVat {
                currencyId
                value
              }
              discountedAmountIncludingVat {
                currencyId
                value
              }
              vatAsAmount {
                currencyId
                value
              }
              discountAsPercentage
              vatAsPercentage
            }
          }
        }
      }
    }

    servicesInfo {
      rejectedOptionGroupIds

      consolidation {
        serviceUsagesGroups {
          _id
          index
          groupingMode
          isOptional
          label
          totalMode

          manualTotal {
            vatId {
              value
            }
          }

          serviceUsages {
            _id

            compiled {
              consolidation {
                quantity {
                  value
                  unitId
                }

                settings {
                  showAmountsInQuotation
                  showCostsInQuotation
                  showMaterialsInQuotation
                  showQuantitiesInQuotation
                }

                service {
                  code
                  title
                  content

                  costUsages {
                    _id

                    quantity {
                      unitId
                      value
                    }

                    cost {
                      code
                      content
                      label
                      title

                      costMargin {
                        label
                        variableValue

                        fixedValue {
                          currencyId
                          value
                        }
                      }

                      ... on FixedCost {
                        amount {
                          currencyId
                          value
                        }
                      }

                      ... on VariableCost {
                        value
                      }
                    }
                  }

                  materialUsages {
                    _id

                    quantity {
                      unitId
                      value
                    }

                    material {
                      code
                      content
                      label
                      title
                    }
                  }

                  value {
                    discountPercentage
                    vatId

                    discountAmount {
                      currencyId
                      value
                    }

                    priceExcludingVat {
                      currencyId
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
      totalCalculation {
        details {
          en
          fr
        }
        result {
          discountAsAmount {
            currencyId
            value
          }
          discountAsPercentage
          discountedAmountExcludingVat {
            currencyId
            value
          }
          discountedAmountIncludingVat {
            currencyId
            value
          }
          undiscountedAmountExcludingVat {
            currencyId
            value
          }
          vatAsAmount {
            currencyId
            value
          }
          vatAsPercentage
        }
        status
        totalMode
      }

      serviceUsagesGroupTotalCalculations {
        groupId

        totalCalculation {
          result {
            undiscountedAmountExcludingVat {
              currencyId
              value
            }
            discountAsAmount {
              currencyId
              value
            }
            discountedAmountExcludingVat {
              currencyId
              value
            }
            discountedAmountIncludingVat {
              currencyId
              value
            }
            vatAsAmount {
              currencyId
              value
            }
            discountAsPercentage
            vatAsPercentage
          }
        }
      }
    }

    kind

    subMissions {
      _id
      code
      consolidation {
        title
      }
      servicesInfo {
        ...DocumentEditorResolvers_QuickAccess_ServicesInfo_Fragment
      }
    }
    consolidation {
      quotationEmitterActor {
        __typename

        thirdParty {
          __typename
          _id

          ... on Organization {
            name
            tradingName
            pennylaneUserAccountId
          }

          ... on Person {
            _id
            fullName
            civilityId
            signatureImageUri
          }

          billingAddress {
            postalInfo {
              locality
            }
            letterFormat
          }

          contactInfo {
            email
            landlineNumber
            mobileNumber
            professionalNumber
          }
        }

        ... on ActorOrganization {
          consolidation {
            legalRepresentatives {
              person {
                _id
                civilityId
                fullName
                signatureImageUri
              }
            }
          }
        }
      }

      externalActors {
        categoryIds
        thirdParty {
          __typename
          ... on Organization {
            name
          }
          ... on Person {
            fullName
            lastName
            firstName
          }
        }
        ... on ActorOrganization {
          references {
            typeId
            value
          }
        }
        ... on ActorPerson {
          references {
            typeId
            value
          }
        }
      }
      quotationReceiverActor {
        __typename

        thirdParty {
          __typename
          _id

          ... on Person {
            fullName
            civilityId
            firstName
          }

          ... on Organization {
            name
            tradingName
          }

          billingAddress {
            letterFormat
          }
        }

        ... on ActorOrganization {
          consolidation {
            quotationContact {
              person {
                civilityId
                fullName
                signatureImageUri
              }
            }
          }
        }
      }
    }
  }
`);
